const EDIT_APP_COMPANY_DRAFT_PREFIX = 'admin:appCompanyDraft:edit:'
export const NEW_APP_COMPANY_DRAFT_KEY = 'admin:appCompanyDraft:new'

const APP_COMPANY_PARAM_FIELDS = [
    'companyCode',
    'companyName',
    'companyNameEn',
    'email',
    'password',
    'isSignUpVisible',
    'limitUsers',
    'planStartTime',
    'planEndTime',
    'memo',
]

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeTextValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

const parseNumberValue = (value, fallbackValue) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

const serializeDateValue = (value) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return ''
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? '' : nextDate.toISOString()
}

const parseDateValue = (value, fallbackValue) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return fallbackValue
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? fallbackValue : nextDate
}

// 기업 폼은 기본 정보 필드만 sessionStorage에 남기고, 도메인/랭킹탭 같은 보조 상태는 제외한다.
export const createAppCompanyDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            companyCode: normalizeTextValue(params.companyCode),
            companyName: normalizeTextValue(params.companyName),
            companyNameEn: normalizeTextValue(params.companyNameEn),
            email: normalizeTextValue(params.email),
            password: normalizeTextValue(params.password),
            isSignUpVisible: parseNumberValue(params.isSignUpVisible, 1),
            limitUsers: normalizeTextValue(params.limitUsers),
            planStartTime: serializeDateValue(params.planStartTime),
            planEndTime: serializeDateValue(params.planEndTime),
            memo: normalizeTextValue(params.memo),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 기업 기본 정보 작성 흐름을 이어간다.
export const applyAppCompanyDraft = ({ baseParams = {}, draft }) => {
    if (!draft) {
        return {
            params: baseParams,
        }
    }

    const draftParams = draft.params || {}
    const nextParams = {
        ...baseParams,
    }

    APP_COMPANY_PARAM_FIELDS.forEach((field) => {
        if (draftParams[field] === undefined) {
            return
        }

        if (field === 'planStartTime' || field === 'planEndTime') {
            nextParams[field] = parseDateValue(draftParams[field], baseParams[field] ?? null)
            return
        }

        if (field === 'isSignUpVisible') {
            nextParams[field] = parseNumberValue(draftParams[field], baseParams[field] ?? 1)
            return
        }

        nextParams[field] = draftParams[field]
    })

    return {
        params: nextParams,
    }
}

export const createEditAppCompanyDraftKey = (companyId) => `${EDIT_APP_COMPANY_DRAFT_PREFIX}${companyId}`

export const readAppCompanyDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppCompanyDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppCompanyDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
